import s from './style.module.scss';
import { Display } from '@/components/Display/Display';
import { fileTypeMap } from '@/utils/Page/constant';
import WebImgage from './Image';
import FileInfo from './FileInfo';
import { getFileIcon } from '@/components/FileType';
import IconImg from './IconImg';
import { useRef } from 'react';
const ChatFile = ({ file }) => {
    const imgRef = useRef(null);
    const onClick = () => {
        if (file.type === fileTypeMap.link) {
            window.open(file.file_url);
        }
        if (file.type === fileTypeMap.img) {
            imgRef.current?.openImg();
        }
    };
    return (
        <>
            <div onClick={onClick} className={s['file-item']} data-from={'chat'} data-type={file.type}>
                <div className={s['left']}>
                    <Display show={file.type === fileTypeMap.img}>
                        <WebImgage ref={imgRef} canClickImage={false} file={file}></WebImgage>
                    </Display>
                    <Display show={file.type === fileTypeMap.file || file.type === fileTypeMap.link}>
                        <IconImg className={s['file-icon']} file={file} />
                    </Display>
                </div>
                <div className={s['right']}>
                    <FileInfo file={file}></FileInfo>
                </div>
            </div>
        </>
    );
};
export default ChatFile;
